const quickLinks = [
  { href: '#home', label: '首页' },
  { href: '#categories', label: '类型分类' },
  { href: '#hot', label: '热门推荐' },
  { href: '#collection', label: '大全合集' },
  { href: '#articles', label: '精选文章' },
  { href: '#faq', label: '常见问题' },
];

const typeLinks = ['狐妖', '猫妖', '花妖', '树妖', '雪女', '河童'];

export default function Footer() {
  return (
    <footer className="bg-secondary-800 text-paper-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          {/* 品牌 */}
          <div className="lg:col-span-2">
            <a href="#home" className="flex items-center gap-2">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-paper-50">
                <i className="ri-ghost-2-line text-xl" aria-hidden="true"></i>
              </span>
              <span className="font-serif text-lg font-bold text-paper-50">
                妖精<span className="text-accent-400">漫画大全</span>
              </span>
            </a>
            <p className="mt-4 max-w-md text-sm leading-7 text-paper-100/75">
              妖精漫画大全免费在线看，收录狐妖、猫妖、花妖等全类型妖精漫画，
              以清晰分类与聚合合集，帮每一位读者快速找到心仪的妖精漫画。
            </p>
          </div>

          {/* 快捷导航 */}
          <div>
            <h3 className="font-serif text-base font-bold text-paper-50">快捷导航</h3>
            <ul className="mt-4 flex flex-col gap-2.5">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-paper-100/75 transition-colors hover:text-accent-300"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* 类型入口 */}
          <div>
            <h3 className="font-serif text-base font-bold text-paper-50">类型入口</h3>
            <ul className="mt-4 flex flex-col gap-2.5">
              {typeLinks.map((type) => (
                <li key={type}>
                  <a
                    href="#categories"
                    className="text-sm text-paper-100/75 transition-colors hover:text-accent-300"
                  >
                    {type}漫画大全
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-paper-100/15 pt-6 sm:flex-row">
          <p className="text-xs text-paper-100/60">
            © 2026 妖精漫画大全 · 精选妖精漫画聚合阅读入口
          </p>
          <p className="text-xs text-paper-100/60">
            <i className="ri-heart-line mr-1" aria-hidden="true"></i>
            专注妖精漫画 · 点开即看
          </p>
        </div>
      </div>
    </footer>
  );
}